import FeaturedItem from './featured-item';

export default FeaturedItem;
